import { useRef, useState, type ReactElement } from "react";

type NavTooltipProps = {
  label: string;
  children: ReactElement;
};

const TOOLTIP_BG = "#262626";

export function NavTooltip({ label, children }: NavTooltipProps) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  function show() {
    const el = wrapRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setCoords({ top: rect.top + rect.height / 2, left: rect.right + 10 });
    setVisible(true);
  }

  return (
    <div
      ref={wrapRef}
      className="relative flex items-center justify-center"
      onMouseEnter={show}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className="pointer-events-none fixed z-50 -translate-y-1/2 whitespace-nowrap rounded shadow-md"
          style={{
            top: coords.top,
            left: coords.left,
            backgroundColor: TOOLTIP_BG,
            fontSize: "13px",
            lineHeight: "1.25",
            padding: "6px 10px",
          }}
          role="tooltip"
        >
          <span
            className="absolute top-1/2 -translate-y-1/2"
            style={{
              left: -6,
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: `6px solid ${TOOLTIP_BG}`,
            }}
            aria-hidden
          />
          <span className="font-normal text-white">{label}</span>
        </div>
      )}
    </div>
  );
}
